import { render } from "./first-time-course.vue?vue&type=template&id=4cf7c614&ts=true"
import script from "./first-time-course.vue?vue&type=script&lang=ts"
export * from "./first-time-course.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__